import type { Installation } from "@sitescene/types";

import { apiClient } from "../client";
import { ENDPOINTS } from "../endpoints";

/** POST /shadow/installations body (matches createInstallationSchema). */
export type CreateInstallationRequest = {
	externalId: string;
	location: string;
};

/**
 * Shadow Realm installations API (org via `X-Shadow-Org` on the client).
 */
export const installationsApi = {
	createInstallation: async (
		body: CreateInstallationRequest,
	): Promise<Installation> => {
		const response = await apiClient.post<Installation>(
			ENDPOINTS.shadow.installations.create,
			body,
		);
		return response.data;
	},

	/**
	 * Names the organization explicitly. The client fills `X-Shadow-Org` only
	 * after the access token arrives, so an organization switch in between
	 * would otherwise cache another organization's list under this one's key.
	 */
	getInstallations: async (orgCode: string): Promise<Installation[]> => {
		const response = await apiClient.get<Installation[]>(
			ENDPOINTS.shadow.installations.list,
			{ headers: { "X-Shadow-Org": orgCode } },
		);
		return response.data;
	},
};
